import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.css';
import { Stack, Grid } from '@mui/material';
import CustomFormSwitch from 'components/utils/CustomComponents/CustomFormSwitch';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { DEFAULT_CURRENCY, ROUTES, STORAGE_KEYS } from 'const';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import {
  PREMIUM_FEATURES,
  SANOFT_WEB_URLS,
  REGISTER_PLANS,
  CONTACT_DETAILS,
  ADD_ONS_DETAILS,
  PLAN_FEATURES,
  ADDITIONAL_FEATURES_LEFT,
  ADDITIONAL_FEATURES_RIGHT,
} from './RegisterConfig';

import FreePlanImg from 'images/Free-plan-img.png';
import keyRegisterImg from 'images/key_register.png';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { OnlinePurchaseContext } from 'Context/OnlinePurchaseContext';
import { ThemeContext } from 'Context/ThemeContext';
import { ShopContext } from 'Context/ShopContext';
import {
  THEME_SANOFT,
  REGISTRATION_TYPE,
  REGISTRATION_CHANNEL,
  COUNTRY_CONFIGRATION,
  DEFAULT_COUNTRY,
  SUBSCRIPTION_TYPE,
} from 'const';
import { Skeleton } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import KeySignupPopup from 'components/popups/KeySignupPopup';
import AddEcsTerminalMacIdPopup from 'components/popups/AddEcsTerminalMacIdPopup';

function RegisterPlan() {
  const {
    purchaseData,
    setPurchaseData,
    loadSubscriptionsAndAddons,
    isLoading: isLoadingInPurchaseContext,
    subscriptionsAndAddons,
  } = useContext(OnlinePurchaseContext);
  const { theme } = useContext(ThemeContext);
  const shopContext = useContext(ShopContext);
  const shop = shopContext?.shop;
  const [yearly, setYearly] = useState(true);
  const [showKeySignupPopup, setShowKeySignupPopup] = useState(false);
  const [addEcsTerminalMacIdPopup, setAddEcsTerminalMacIdPopup] = useState(false);
  const [macIdUpdated, setMacIdUpdated] = useState(false);

  const history = useHistory();

  const handleChangeValidity = (event) => {
    setYearly(event.target.checked);
  };

  const redirectWeb = (url) => {
    window.location.href = url;
  };

  const handleWhatsAppRedirect = () => {
    const url = `https://api.whatsapp.com/send?phone=919074511134&text=${encodeURIComponent(
      'Need help on Sanoft POS'
    )}`;
    window.open(url, '_blank');
  };

  const getDealerFromStorage = () => {
    const itemStr = localStorage.getItem('dealer');

    if (!itemStr) return null;

    try {
      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem('dealer'); // expired
        return null;
      }

      return Number(item.value);
    } catch (e) {
      localStorage.removeItem('dealer'); // corrupted data
      return null;
    }
  };

  const handlePurchaseSubscription = (subscription = null, type = null, action = null) => {
    const amount = yearly ? subscription?.yearly_price || 0 : subscription?.monthly_price || 0;
    const country = subscription?.country || DEFAULT_COUNTRY;
    const tax = amount * (COUNTRY_CONFIGRATION[country]?.tax || 0);

    setPurchaseData((prevState) => ({
      ...prevState,
      subscription: subscription ? { id: subscription?.id, key: subscription?.key, validity: yearly ? 365 : 30 } : null,
      yearly,
      type,
      tax,
      amount,
      payable: amount + tax,
      dealer_id: getDealerFromStorage(),
      action_type: action || (shop ? REGISTRATION_TYPE.RENEWAL : REGISTRATION_TYPE.NEW),
      currency: subscription?.currency || DEFAULT_CURRENCY,
      country,
    }));

    if (type === REGISTRATION_TYPE.TRIAL) {
      history.push(
        `${ROUTES.SIGNUP}?registration_type=${REGISTRATION_TYPE.TRIAL}&registration_channel=${REGISTRATION_CHANNEL.ONLINE}&subscription_key=${subscription?.key}`
      );
    } else if (type === REGISTRATION_TYPE.FREE) {
      history.push(
        `${ROUTES.SIGNUP}?registration_type=${REGISTRATION_TYPE.FREE}&registration_channel=${REGISTRATION_CHANNEL.ONLINE}`
      );
    } else if (type === 'register_with_key') {
      history.push(
        `${ROUTES.SIGNUP}?registration_type=${REGISTRATION_TYPE.NEW}&registration_channel=${REGISTRATION_CHANNEL.KEY}&subscription_key=${subscription?.key}`
      );
    } else {
      history.push(
        `${ROUTES.SIGNUP}?registration_type=${REGISTRATION_TYPE.NEW}&registration_channel=${REGISTRATION_CHANNEL.ONLINE}&subscription_key=${subscription?.key}`
      );
    }
  };

  const sortedSubscriptionData = REGISTER_PLANS.map((key) =>
    (subscriptionsAndAddons?.subscriptions || []).find((s) => s.key === key)
  ).filter((s) => s !== undefined);

  const handleKeyRegister = (data) => {
    setShowKeySignupPopup(false);
    if ((data?.add_ons || []).find((addon) => addon?.key === 'ecs_terminal') && !macIdUpdated) {
      setAddEcsTerminalMacIdPopup(true);
      return;
    }
    handlePurchaseSubscription(null, 'register_with_key');
  };

  const handleSetMacId = (macId = null) => {
    localStorage.setItem(STORAGE_KEYS.MAC_ID, macId);
    setAddEcsTerminalMacIdPopup(false);
    setMacIdUpdated(true);
    handleKeyRegister();
  };

  const getSubscriptionStyle = (plan) => {
    return [
      styles.planItemContainer,
      plan === 'sanoft-lite'
        ? styles.planContainerLeft
        : plan === 'sanoft-pro'
        ? styles.planContainerHeilight
        : styles.planContainerRight,
    ].join(' ');
  };

  const saveDealerIdIfPresent = () => {
    const url = new URL(window.location.href);
    const dealerId = url.searchParams.get('dealer');

    if (dealerId) {
      const now = new Date();
      const expiry = now.getTime() + 4 * 24 * 60 * 60 * 1000; // 4 days in ms

      const data = {
        value: dealerId,
        expiry: expiry,
      };

      localStorage.setItem('dealer', JSON.stringify(data));

      url.searchParams.delete('dealer');
      window.history.replaceState({}, document.title, url.pathname + url.search);
    }
  };

  const contact_info =
    CONTACT_DETAILS[subscriptionsAndAddons?.subscriptions?.[0]?.country || 'IN'] || CONTACT_DETAILS['IN'];

  useEffect(() => {
    if (theme?.name !== THEME_SANOFT) return;
    loadSubscriptionsAndAddons();
    saveDealerIdIfPresent();
    //eslint-disable-next-line
  }, []);

  return (
    <div className={styles.container}>
      <div id="sanoft-custom-header">
        <h1 className={styles.newHeading}>
          The <span className={styles.highlightedText}>#1-rated</span> restaurant point-of-sale.
          <br />
          Priced to maximize your ROI.
        </h1>
        <ul className={styles.featureList}>
          <li className={styles.featureItem}>
            <div className={styles.featureIconWrapper}>
              <CheckRoundedIcon className={styles.featureIconTick} />
            </div>
            Transparent pricing
          </li>
          <li className={styles.featureItem}>
            <div className={styles.featureIconWrapper}>
              <CheckRoundedIcon className={styles.featureIconTick} />
            </div>
            No long-term contracts or hidden fees
          </li>
          <li className={styles.featureItem}>
            <div className={styles.featureIconWrapper}>
              <CheckRoundedIcon className={styles.featureIconTick} />
            </div>
            Free setup & personalized onboarding
          </li>
          <li className={styles.featureItem}>
            <div className={styles.featureIconWrapper}>
              <CheckRoundedIcon className={styles.featureIconTick} />
            </div>
            24/7 priority support
          </li>
        </ul>
        <p className={styles.descriptionParagraph}>
          You deserve better from your technology. Better options. Better prices. And better value. That's why Sanoft
          offers flexible pricing that's designed to fit your budget and grow your bottom line.
        </p>
      </div>
      <Grid container item xs={12} className={styles.planContainer} style={{ paddingTop: 0 }}>
        <Grid container className={styles.planWrapper}>
          {theme?.name === THEME_SANOFT && (
            <>
              <Grid item xs={12} className={styles.filterContainer}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <span className={styles.text} style={{ paddingTop: 7 }}>
                    Monthly
                  </span>
                  <CustomFormSwitch checked={yearly} onChange={handleChangeValidity} />
                  <span className={styles.text} style={{ paddingTop: 7 }}>
                    Yearly
                  </span>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Grid
                  container
                  columnSpacing={4}
                  rowSpacing={4}
                  className={styles.planListContainer}
                  justifyContent="center"
                >
                  {isLoadingInPurchaseContext ? (
                    <>
                      <Grid item xs={12} md={4}>
                        <Skeleton variant="rectangular" height={400} animation="wave" style={{ borderRadius: 24 }} />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Skeleton variant="rectangular" height={400} animation="wave" style={{ borderRadius: 24 }} />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Skeleton variant="rectangular" height={400} animation="wave" style={{ borderRadius: 24 }} />
                      </Grid>
                    </>
                  ) : (
                    (() => {
                      const litePlan = sortedSubscriptionData.find((s) => s?.key === 'sanoft-lite');
                      const proPlan = sortedSubscriptionData.find((s) => s?.key === 'sanoft-pro');
                      const elitePlan = sortedSubscriptionData.find((s) => s?.key === 'sanoft-elite');

                      const renderPlanCard = (plan) => {
                        if (!plan) return null;
                        const isPro = plan?.key === 'sanoft-pro';

                        const planDescriptions = {
                          'sanoft-lite': 'Perfect start for small businesses',
                          'sanoft-pro': 'Advanced features for growing businesses',
                          'sanoft-elite': 'Take your operations to the next level',
                        };

                        const features = PLAN_FEATURES[plan?.key] || plan?.config?.promotional_texts || [];

                        return (
                          <div className={getSubscriptionStyle(plan?.key)}>
                            {isPro && (
                              <div className={styles.bestValueBadge}>
                                <span style={{ fontSize: 12 }}>★</span> Best value
                              </div>
                            )}
                            <h2>{plan.name || plan.key}</h2>
                            <p className={styles.note}>{planDescriptions[plan?.key] || plan?.description}</p>

                            <div className={styles.planPriceContainer}>
                              <span className={styles.planPriceOn}>
                                {plan?.currency} {yearly ? plan?.yearly_price : plan?.monthly_price}
                              </span>
                              <span className={styles.priceUnit}>/{yearly ? 'Year' : 'Month'}</span>
                            </div>

                            <button className={styles.btn} onClick={() => handlePurchaseSubscription(plan)}>
                              Register Now
                            </button>

                            <button
                              className={styles.btnTrial}
                              onClick={() => handlePurchaseSubscription(plan, REGISTRATION_TYPE.TRIAL)}
                            >
                              Free Trial
                            </button>

                            <div className={styles.divider} />

                            <div className={styles.featuresContainer}>
                              <ul className={styles.listContainer}>
                                {features.map((feature) => (
                                  <li key={feature} className={styles.featureItemRow}>
                                    <RadioButtonCheckedIcon className={styles.targetIcon} />
                                    <span>{feature}</span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        );
                      };

                      return (
                        <Grid container spacing={3}>
                          {/* Left Column: Sanoft Lite */}
                          <Grid item xs={12} md={4}>
                            {renderPlanCard(litePlan)}
                          </Grid>

                          {/* Right Area: Pro + Elite + Additional Features */}
                          <Grid item xs={12} md={8}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={6}>
                                {renderPlanCard(proPlan)}
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                {renderPlanCard(elitePlan)}
                              </Grid>
                              <Grid item xs={12}>
                                <div className={styles.additionalFeaturesCard}>
                                  <div className={styles.additionalHeaderBanner}>
                                    ADDITIONAL FEATURES
                                  </div>
                                  <div className={styles.additionalBody}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} sm={6}>
                                        <ul className={styles.listContainer}>
                                          {ADDITIONAL_FEATURES_LEFT.map((feat) => (
                                            <li key={feat} className={styles.featureItemRow}>
                                              <RadioButtonCheckedIcon className={styles.targetIcon} />
                                              <span>{feat}</span>
                                            </li>
                                          ))}
                                        </ul>
                                      </Grid>
                                      <Grid item xs={12} sm={6}>
                                        <ul className={styles.listContainer}>
                                          {ADDITIONAL_FEATURES_RIGHT.map((feat) => (
                                            <li key={feat} className={styles.featureItemRow}>
                                              <RadioButtonCheckedIcon className={styles.targetIcon} />
                                              <span>{feat}</span>
                                            </li>
                                          ))}
                                        </ul>
                                      </Grid>
                                    </Grid>
                                  </div>
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      );
                    })()
                  )}
                </Grid>
              </Grid>
            </>
          )}

          <p className={styles.subNote}>Note: Additional charges may apply for installation and training services.</p>

          {false && theme?.name === THEME_SANOFT && (
            <Grid item xs={12} className={styles.boxContainer}>
              <img
                src={FreePlanImg}
                alt="Sanoft POS free trial plan – best billing software and best billing app for small businesses"
                className={styles.freeImg}
              />
              <Grid className={styles.trailFeatureContainer}>
                <h2 className={styles.header2}>Forever Free Plan</h2>
                <p>Get full access to our PREMIUM plan with all features — free trial available!.</p>
                <Grid>
                  <ul className={styles.trialFeatureList}>
                    {PREMIUM_FEATURES.map((feature) => (
                      <li className={styles.featureName} key={feature}>
                        <CheckRoundedIcon className={styles.iconSmall} /> {feature}
                      </li>
                    ))}
                  </ul>
                  <button
                    className={styles.btn}
                    disabled={shop?.subscription?.type === SUBSCRIPTION_TYPE.FREE}
                    onClick={() => handlePurchaseSubscription(null, REGISTRATION_TYPE.FREE)}
                  >
                    {shop?.subscription?.type === SUBSCRIPTION_TYPE.FREE ? 'Current Plan' : 'Sign up for free'}
                  </button>
                </Grid>
              </Grid>
            </Grid>
          )}

          <Grid item xs={12} className={styles.boxContainer}>
            <img
              src={keyRegisterImg}
              alt="Sanoft POS register – best billing software and best billing app for small businesses"
              className={styles.freeImg}
            />
            <Grid className={styles.trailFeatureContainer}>
              <h2 className={styles.header2}>Sign up with key</h2>
              <p>This feature is only for dealers</p>
              <Grid display="flex" flexDirection="column" alignItems="flex-start">
                <span className={styles.description}>
                  Use a special key provided to create and manage new shops. This key includes specific subscription
                  types and add-on options, enabling a streamlined registration and setup process.
                </span>
                <span className={styles.subText} style={{ marginBottom: 12 }}>
                  Verify your key. If it is valid, it will display the subscriptions and add-ons available. These
                  options are specified and not changeable.
                </span>
                <button
                  className={styles.btn}
                  onClick={() => {
                    setShowKeySignupPopup(true);
                  }}
                >
                  Sign up with key
                </button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {theme?.name === THEME_SANOFT && (
        <>
          <Grid item xs={12} className={styles.addonsContainer}>
            <Grid container className={styles.addonsDetails}>
              <Grid item xs={12}>
                <h2 className={styles.premiumHeader}>Enhance Your Experience with Add-Ons</h2>
              </Grid>
              <Grid item xs={12}>
                <Grid container columnSpacing={2} rowSpacing={{ xs: 1, md: 3 }}>
                  {(subscriptionsAndAddons?.add_ons || [])
                    .filter((addon) => !addon?.config?.variants)
                    .map((addon) => {
                      const addonDetails = ADD_ONS_DETAILS[addon?.key];

                      if (!addonDetails) {
                        return null;
                      }

                      const IconComponent = addonDetails?.icon;
                      const currency = COUNTRY_CONFIGRATION[addon?.country]?.currency || DEFAULT_CURRENCY;

                      return (
                        <Grid item xs={6} md={4} className={styles.addonWrapper} key={addon.key}>
                          <Grid className={styles.addonCard}>
                            <Grid className={styles.cardWrapper}>
                              <Grid className={styles.addonHeadContainer}>
                                {IconComponent && <IconComponent className={styles.addonHeaderIcon} />}
                                <span>{addonDetails?.name}</span>
                              </Grid>
                              <div className={styles.addonPriceRow}>
                                <span className={styles.addonPrice}>
                                  {currency}
                                  {yearly ? addon?.yearly_price : addon?.monthly_price}
                                </span>
                                <span className={styles.addonLimit}>{yearly ? '/Year' : '/Month'}</span>
                              </div>
                              <span className={styles.addonMsg}>{addonDetails?.message}</span>
                            </Grid>
                          </Grid>
                        </Grid>
                      );
                    })}
                </Grid>
              </Grid>
              <Grid item xs={12} className={styles.addonDeclaimer}>
                <p className={styles.addonDeclaimer}>*Some addons are not supported in the STANDARD plan.</p>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className={styles.contactBG}>
            <Grid container rowSpacing={2} className={styles.contactWrapper}>
              <Grid item xs={12} md={6} className={styles.contactInfo}>
                <span>Contact Us</span>
                <p>If you have any questions or need any assistance after business hours please get in touch</p>
                <Grid container spacing={1} marginTop={4} marginBottom={3}>
                  <Grid item xs={4}>
                    <h5>EMAIL</h5>
                  </Grid>
                  <Grid item xs={8}>
                    <h5>{contact_info?.email}</h5>
                  </Grid>
                  <Grid item xs={4}>
                    <h5>PHONE</h5>
                  </Grid>
                  <Grid item xs={8}>
                    <h5>{contact_info?.phone}</h5>
                  </Grid>
                </Grid>
                <h5>OFFICE ADDRESS:</h5>
                <h6>{contact_info?.address}</h6>
                <Grid className={styles.socialMediaWrapper}>
                  <FacebookIcon className={styles.icon} /> <InstagramIcon className={styles.icon} />{' '}
                  <YouTubeIcon className={styles.icon} /> <LinkedInIcon className={styles.icon} />
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} className={styles.sentMessage}>
                <form action="https://formspree.io/f/xbjwzzey" method="POST">
                  <label htmlFor="contact-us-name">YOUR NAME</label>
                  <br />
                  <input type="text" id="contact-us-name" name="Name" placeholder="Enter your name" />
                  <br />
                  <label htmlFor="contact-us-email">YOUR EMAIL</label>
                  <br />
                  <input type="text" id="contact-us-email" name="Email" placeholder="Enter your email address" />
                  <br />
                  <label htmlFor="contact-us-message">YOUR MESSAGE</label>
                  <br />
                  <input type="text" id="contact-us-message" name="Message" placeholder="Enter your message here..." />
                  <br />
                  <button type="submit" className="contact-us-submit-button" name="button-sent-message">
                    SEND MESSAGE
                  </button>
                </form>
              </Grid>
              <Grid item xs={12} className={styles.footer}>
                <span>© 2024 Sanoft Technologies. All Rights Reserved</span>
                <Grid display="flex">
                  <p onClick={() => redirectWeb(SANOFT_WEB_URLS.PRIVECY_POLICY)}>Privacy Policy</p>
                  <p onClick={() => redirectWeb(SANOFT_WEB_URLS.TERMS)}>Terms & Conditions</p>
                  <p onClick={() => redirectWeb(SANOFT_WEB_URLS.REFUND_POLICY)}>Refund Policy</p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}

      {showKeySignupPopup && (
        <KeySignupPopup handleClose={() => setShowKeySignupPopup(false)} handleKeyRegister={handleKeyRegister} />
      )}
      {addEcsTerminalMacIdPopup && (
        <AddEcsTerminalMacIdPopup
          handleClose={() => {
            setAddEcsTerminalMacIdPopup(false);
          }}
          purchaseData={purchaseData}
          handleSetMacId={handleSetMacId}
        />
      )}
      <div className={styles.floatingWhatsappBtn} onClick={handleWhatsAppRedirect}>
        <WhatsAppIcon style={{ fontSize: '32px', color: '#fff' }} />
      </div>
    </div>
  );
}

export default RegisterPlan;
